import React, { memo } from 'react'
import { Helmet } from 'react-helmet-async'
import { SITE_ORIGIN, SITE_NAME } from '../../seo/siteConfig'

const jsonLd = {
  '@context': 'https://schema.org',
  '@type': 'TravelAgency',
  name: SITE_NAME,
  url: SITE_ORIGIN,
  image: `${SITE_ORIGIN}/images/og-image.jpg`,
  address: {
    '@type': 'PostalAddress',
    addressLocality: 'Discovery Bay',
    addressCountry: 'JM',
  },
  areaServed: [
    { '@type': 'City', name: 'Montego Bay' },
    { '@type': 'City', name: 'Ocho Rios' },
    { '@type': 'City', name: 'Negril' },
    { '@type': 'City', name: 'Discovery Bay' },
  ],
  description:
    'Jamaica tours, Montego Bay airport shuttles, group bus transport, and car rental from Discovery Bay.',
  makesOffer: [
    { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Island tours and custom trips' } },
    { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Airport and hotel shuttle service' } },
    { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Car rental' } },
    { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Chauffeur service' } },
  ],
}

function LocalBusinessJsonLd() {
  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
    </Helmet>
  )
}

export default memo(LocalBusinessJsonLd)
